import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftCircle, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImpersonationBanner() {
  const { refreshUser, user } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState({ impersonating: false });
  const [busy, setBusy] = useState(false);

  const checkStatus = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/superadmin/impersonation-status`, { withCredentials: true });
      setInfo(data);
    } catch { setInfo({ impersonating: false }); }
  }, []);

  useEffect(() => { checkStatus(); }, [checkStatus, user?.id]);

  const stop = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/superadmin/stop-impersonating`, {}, { withCredentials: true });
      await refreshUser();
      await checkStatus();
      toast.success('Tornato SuperAdmin');
      navigate('/superadmin/test-profiles');
    } catch (e) {
      toast.error('Errore ripristino sessione');
    } finally {
      setBusy(false);
    }
  };

  if (!info.impersonating) return null;

  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[200] bg-amber-500 text-white shadow-md">
      <div className="max-w-2xl mx-auto px-3 py-2 flex items-center gap-2">
        <Sparkles size={18} className="flex-shrink-0" />
        <p className="text-xs sm:text-sm flex-1 truncate">
          <b>Test mode:</b> stai navigando come <b>{info.current_name || info.current_email}</b> ({info.current_role})
        </p>
        <button
          data-testid="banner-stop-impersonating"
          onClick={stop}
          disabled={busy}
          className="flex-shrink-0 flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded-full px-3 py-1 text-xs font-medium disabled:opacity-60"
        >
          <ArrowLeftCircle size={14} /> Torna SuperAdmin
        </button>
      </div>
    </div>
  );
}
